import React, {useEffect, useState} from 'react';
import RLookUpModal from "./RLookUpModal";
import {calculateTotalSum, isPaymentAndFactorSumEqual, sumOfPaymentTable} from "../SellFactorFunctionsSadan";
import {toast} from "react-toastify";
import commaSeparator, {formatToPersianAddComma, parseToEnRemoveComma} from "../../../utils/CommaSeparator";


const CacheAndBank = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {
  const [isOpen, setIsOpen] = useState(false);


  useEffect(() => {

    const remain = calculateTotalSum(sendData).sum - sumOfPaymentTable(sendData.priceData)
    const remainValue = remain === 0 ? "" : remain
    setComponentData({currentFundInputValue: remainValue, currentBankAccountInputValue: remainValue})

  }, [sendData])

  function addToTableData(type) {

    if (type !== 'fund') {
      if ((sendData.bank.id === undefined || sendData.bank.id === "") && type !== 'fund') {
        toast("لطفا یک بانک انتخاب کنید.")
        return
      }
    }

    const price = (type === "fund") ? componentData.currentFundInputValue : componentData.currentBankAccountInputValue

    const id = (type === "fund") ? initialData.fund.id : sendData.bank.id;
    const uniqId = (Math.random() * 1000000000);
    const name = (type === "fund") ? initialData.fund.name : sendData.bank.name
    const recordId = ""; // back End Need This

    if (price === "") {
      toast("مبلغ نمیتواند خالی باشد.")
      return
    }

    // Validation: preview what priceData will look like using closure value (acceptable for guard checks)
    const previewPriceData = [...sendData.priceData];
    let previewAdded = false;
    previewPriceData.forEach(v => {
      if (parseInt(v.id) === parseInt(id) && v.type === type) {
        previewAdded = true;
        v.price = parseInt(v.price) + parseInt(price);
      }
    })
    if (!previewAdded) {
      previewPriceData.unshift({uniqId, recordId, id, price, type, name})
    }

    if (calculateTotalSum({...sendData}).sum < sumOfPaymentTable([...previewPriceData])
      || (calculateTotalSum(sendData).sum === 0)
    ) {
      toast.error(`در صورت پرداخت ${commaSeparator(price)}  مبلغ دریافتی از مبلغ کل بیشتر میشود.
      لطفا مبلغ دریافتی را اصلاح کنید.
      `)
      return;
    }

    // State update: use functional updater to read latest priceData from prev (avoids stale closure)
    setSendData(prev => {
      const currentPriceData = [...prev.priceData];
      let addedToTable = false;
      currentPriceData.forEach(v => {
        if (parseInt(v.id) === parseInt(id) && v.type === type) {
          addedToTable = true;
          v.price = parseInt(v.price) + parseInt(price);
        }
      })
      if (!addedToTable) {
        currentPriceData.unshift({uniqId, recordId, id, price, type, name})
      }
      return {priceData: currentPriceData};
    })

    if (type === 'fund') {
      setComponentData({currentFundInputValue: ""})
    } else {
      setComponentData({currentBankAccountInputValue: ""})
    }

  }

  function deleteRowHandler(uniqId) {
    // Use functional updater to read latest priceData and avoid stale closure
    setSendData(prev => ({
      priceData: prev.priceData.filter(v => v.uniqId !== uniqId)
    }))
  }

  return (<div>
    {/* صندوق*/}

    {initialData.fundAccess &&
      <>
        <div className={"d-flex  mb-2 justify-content-between"}>

          <div style={{flexBasis: '49%'}}>
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                fill="currentColor"
                className="bi bi-person-circle"
                viewBox="0 0 16 16"
              >
                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                <path
                  fillRule="evenodd"
                  d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                />
              </svg>
            </>
            <span style={{fontSize:14, wordBreak:'break-all'}} >{initialData.fund.name}:</span>
          </div>
          <div style={{flexBasis: '49%'}}>
            <div className={'divgroup'}>
              <label htmlFor={'componentData__currentFundInputValue'}>مبلغ</label>
              <input
                id={'componentData__currentFundInputValue'}
                className={"form-control newinput"} type={"text"}
                onChange={e => {
                  setComponentData({currentFundInputValue: parseToEnRemoveComma(e.target.value)})
                }}
                // defaultValue={
                //   componentData.currentFundInputValue
                //     ||
                //   ((calculateTotalSum(sendData) - sumOfPaymentTable(sendData.priceData)) === 0 ? "" : (calculateTotalSum(sendData) - sumOfPaymentTable(sendData.priceData)))
                // }
                value={(componentData.currentFundInputValue === 0 || componentData.currentFundInputValue === "") ? "" :
                  formatToPersianAddComma(componentData.currentFundInputValue)}


                onKeyDown={(e) => {

                  if (e.key === "Enter") {
                    e.preventDefault()
                    addToTableData("fund")
                  }
                }}
                placeholder={"مبلغ و Enter"}
              />
            </div>
            {/* دکمه فقط توی موبایل دیده بشه*/}
            <span className={'d-sm-block d-md-none btn btn-primary'} onClick={() => addToTableData("fund")}> تایید از صندوق </span>

          </div>
        </div>
      </>
    }


    <div className={"d-flex justify-content-between"}>
      <div style={{flexBasis: '49%'}}>

        <div
          style={{fontSize: 12}}
          className={" btn btn-secondary"}
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(true)
          }}
        >
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={16}
              height={16}
              fill="currentColor"
              className="bi bi-person-vcard-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm9 1.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5ZM9 8a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4A.5.5 0 0 0 9 8Zm1 2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Zm-1 2C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 0 2 13h6.96c.026-.163.04-.33.04-.5ZM7 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"/>
            </svg>
          </>
          {sendData?.bank?.name}</div>
      </div>
      <div style={{flexBasis: '49%'}}>
        <div className={'divgroup'}>
          <label htmlFor={'componentData__currentBankAccountInputValue'}>مبلغ</label>
          <input
            id={'componentData__currentBankAccountInputValue'}
            className={"form-control"} type={"text"}
                 onChange={e => setComponentData({currentBankAccountInputValue: parseToEnRemoveComma(e.target.value)})}
                 onKeyDown={(e) => {
                   if (e.key === "Enter") {
                     e.preventDefault()
                     addToTableData("bank")
                   }
                 }}
                 value={componentData.currentBankAccountInputValue === 0 || componentData.currentBankAccountInputValue === "" ? "" :
                   formatToPersianAddComma(componentData.currentBankAccountInputValue)}
                 placeholder={"مبلغ و Enter"}
          />
        </div>
        {/* دکمه فقط توی موبایل دیده بشه*/}
        <span className={'d-sm-block d-md-none btn btn-primary'} onClick={() => addToTableData("bank")}> تایید از بانک </span>
      </div>
    </div>
    <>
      {isOpen && <RLookUpModal
        id={initialData.bankRLookUpId}
        callBackDataHandler={(incomingData) => {
          // alert(incomingData)
          console.log(incomingData)

          setSendData({
            // currentSelectedBankAccountId: incomingData.na_743, currentSelectedBankAccountName: incomingData.na_744,
            bank: {id: incomingData.na_743, name: incomingData.na_744}
          })
          // factorDataSetter({"rLookUpData": incomingData, isOpenModalSelectCarRLookUp: false})
          // setSendData({...sendData, IDKHOD: incomingData})

        }}
        modalHandler={[isOpen, (isOpen) => setIsOpen(isOpen)]}
      />}
    </>


    <div

      className={(sumOfPaymentTable(sendData.priceData) !== 0 && isPaymentAndFactorSumEqual(sendData) === true) ?
        "bg__green__30 form-control mt-2" : "form-control mt-2"}
      style={{
        minHeight: '45px', maxHeight: 120, overflowY: 'scroll',
        fontSize: '0.7rem',
        // borderRadius: 5,
        // margin:'0 auto',
        // width:'100%',
      }}
    >
      <>

        {
          sendData.priceData.length > 0 ?
            sendData.priceData.map((v, index) =>
              <ul className={"d-flex "} key={index}>
                {/*<li>{v.id}</li>*/}
                <li style={{
                  border: '1px solid rgba(0,0,0,0.09  )',
                  // minWidth: 100,
                  // maxWidth: 120,
                  padding: 5,
                  width: 90,
                  overflow: 'hidden'
                }}>{v.name}</li>
                <li style={{
                  border: '1px solid rgba(0,0,0,0.09  )',
                  // minWidth: 80,
                  // maxWidth: 90,
                  padding: 5,
                  width: 60,
                  overflow: 'hidden'
                }}>{formatToPersianAddComma(v.price)}</li>
                <li style={{
                  border: '1px solid rgba(0,0,0,0.09  )',
                  // minWidth: 40,
                  // maxWidth: 40,
                  padding: 5,
                  width: 30,
                  overflow: 'hidden',
                  color: 'red',
                  textAlign: 'center',
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                    onClick={() => deleteRowHandler(v.uniqId)}>
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         className="bi bi-x-circle-fill" viewBox="0 0 16 16">
                      <path
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                    </svg>
                  </>
                </li>
              </ul>
            ) : <div className={"opacity-25"}>لیست پرداخت</div>
        }
      </>

    </div>
  </div>);
};

export default CacheAndBank;
